module.exports = __webpack_public_path__ + "img/arrow_down_3.f763dd11.svg";